export { default } from './Earn';
